// extracted by mini-css-extract-plugin
export default {"tab_component":"LinesTab_tab_component__SdNFo","tab_div":"LinesTab_tab_div__Bbc91","tab-detail":"LinesTab_tab-detail__N27wG","tab_detail_active":"LinesTab_tab_detail_active__4Ws4p"};